import React from 'react';
import { Link as RouterLink } from 'react-router-dom';
import { Box, Button, Container, Typography } from '@mui/material';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import Navbar from '../components/Navbar';

const NotFound = () => {
  return (
    <>
      <Navbar />
      <Container maxWidth="md">
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            minHeight: '70vh',
            textAlign: 'center',
          }}
        >
          <ErrorOutlineIcon sx={{ fontSize: 100, color: 'primary.main', mb: 2 }} />
          <Typography variant="h1" sx={{ fontSize: { xs: '4rem', md: '6rem' }, mb: 2 }}>
            404
          </Typography>
          <Typography variant="h4" color="text.secondary" gutterBottom>
            Page Not Found
          </Typography>
          <Typography variant="body1" color="text.secondary" sx={{ mb: 4, maxWidth: 500 }}>
            The page you are looking for doesn't exist or has been moved.
          </Typography>
          <Box sx={{ display: 'flex', gap: 2 }}>
            <Button
              variant="contained"
              color="primary"
              component={RouterLink}
              to="/"
            >
              Go Home
            </Button>
            <Button
              variant="outlined"
              component={RouterLink}
              to="/dashboard"
            >
              My Drawings
            </Button>
          </Box>
        </Box>
      </Container>
    </>
  );
};

export default NotFound;